import React, { useEffect, useRef, useState } from 'react';
import ReactGA from 'react-ga4';
import { useHistory } from 'react-router-dom';
import { Badge } from '@mui/material';
import { NOTIFICATIONS_ROUTER } from '@icoach/router/routerPath';
import { Icons, IconButton } from "@curves/ui-base";
import useNotificationApi from '@apis/useNotificationApi';

const NotificationBellBox = () => {
    const { getNotificationCountApi } = useNotificationApi();
    const history = useHistory();
    const [count, setCount] = useState(0);
    const isMounted = useRef(true);

    const doNotificationCount = async () => {
        const resp = await getNotificationCountApi();
        isMounted.current && setCount(resp);
    };

    const handleNotifyOnClick = () => {
        ReactGA.event({ category: '首頁鈴鐺通知', action: '點擊首頁鈴鐺通知', label: '鈴鐺' });
        history.push(NOTIFICATIONS_ROUTER.BASE);
    };

    useEffect(
        () => {
            doNotificationCount();
            return () => {
                isMounted.current = false;
            };
        },
        // eslint-disable-next-line
        []
    );

    return (
        <IconButton onClick={handleNotifyOnClick}>
            <Badge badgeContent={count} color="error">
                <Icons.BellSolid htmlColor="white" />
            </Badge>
        </IconButton>
    );
};

export default NotificationBellBox;
